import { Redirect, useLocation, useRoute, useSearchParams } from "wouter";
import { DownloadMusio, Licenses, MusioPlus, ProfileSettingsForm } from "@/features/account";
import { useEffect } from "react";
import useAuth from "@/contexts/auth/auth-context";

export default function AccountPage() {
  const [_, params] = useRoute('/:tab');
  // this ensures that even if we're at the root, we'll still go to the profile page
  const currentTab = params?.tab || "profile";
  const { user } = useAuth();
  const [location, navigate] = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (user === null) {
      const sp = searchParams.size > 0 ? `?${searchParams.toString()}` : "";
      const encoded = encodeURIComponent(`account${location}${sp}`);
      navigate(`~/login?redirect-to=${encoded}`);
      return;
    }
  }, [user]);

  const renderSettingView = () => {
    switch (currentTab) {
      case "profile": return <ProfileSettingsForm />;
      case "download-musio": return <DownloadMusio />;
      case "musio-plus": return <MusioPlus />;
      case "licenses": return <Licenses />;
      default: return <Redirect to="~/404" />;
    }
  };

  return renderSettingView();
}
